import { Component, Input, inject } from '@angular/core';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-cropper-dialog',
  templateUrl: './cropper-dialog.component.html',
})
export class CropperDialogComponent {

  data: {
    image: File;
    ratio: number;
    resizeToWidth: any
  } = inject(MAT_DIALOG_DATA);
  result!: any;
  showCropper = false;
  scale = 1;
  transform: ImageTransform = {
    translateUnit: 'px'
  };

  @Input() resizeToWidth = this.data.resizeToWidth ? this.data.resizeToWidth : 500;
  constructor(
    private dialogRef: MatDialogRef<CropperDialogComponent>
  ) { }

  imageLoaded() {
    // console.log(this.data.image);
    
    this.showCropper = true;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.result = event;
    // console.log(event)
  }

  zoomOut() {
    this.scale -= .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomIn() {
    this.scale += .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  saveImage() {
    this.dialogRef.close(this.result);
    // console.log(this.resizeToWidth)
  }
}
